import React from 'react';
import Typography from '@material-ui/core/Typography';
import { Section } from 'common';
import strings from 'strings';

export const CompanySummary = ({ company }) => {
  const { name, about } = company || {};

  return (
    <Section
      title={strings.inventory.jobOrders.profile.jobDescriptionTab.sections.companySummary.title}
    >
      {name ? (
        <Typography variant="subtitle1">{name}</Typography>
      ) : (
        <Typography>
          {strings.inventory.jobOrders.profile.jobDescriptionTab.sections.companySummary.empty}
        </Typography>
      )}

      {about && (
        <Typography variant="body1">
          {about ||
            strings.inventory.jobOrders.profile.jobDescriptionTab.sections.companySummary.empty}
        </Typography>
      )}
    </Section>
  );
};
